import React from "react";
import { H1 } from "../Headers";
import styled from "styled-components";
import ContactListWithData from "../contacts/ContactListWithData";

const Container = styled.div`
  margin: 3em;
`;

const ManageContacts = () => {
  return (
    <Container>
      <H1>Manage Users</H1>
      <ContactListWithData />
    </Container>
  );
};

export default ManageContacts;
